/**
 * Is the socket alive, or merely open?
 *
 * `readyState === OPEN` is what the browser believes, and through a relay —
 * two more TCP hops, two more NAT tables — the browser can believe it for
 * minutes after the path went dead: nothing arrives, nothing errors, and the
 * app is deaf while showing every sign of being connected (both phones,
 * 2026-09-02). The heartbeat used to be one-way: sent, never awaited.
 *
 * This is Signal's KeepAliveSender, stated once: every `intervalMs` send a
 * heartbeat and expect SOMETHING back within `graceMs` — the server's
 * heartbeat_ack, or any other frame, whichever comes first. Silence is death:
 * the socket is closed on purpose, and the ordinary reconnect takes over.
 * `probe()` asks the question right now — on return to foreground, or when a
 * send got no acknowledgement — instead of waiting for the next interval.
 */
export const HEARTBEAT_INTERVAL_MS = 30_000;
export const HEARTBEAT_GRACE_MS = 15_000;

export function makeWatchdog({ send, onDead, intervalMs = HEARTBEAT_INTERVAL_MS, graceMs = HEARTBEAT_GRACE_MS,
                               timers = { setInterval: (f, ms) => globalThis.setInterval(f, ms), clearInterval: (h) => globalThis.clearInterval(h),
                                          setTimeout: (f, ms) => globalThis.setTimeout(f, ms), clearTimeout: (h) => globalThis.clearTimeout(h) } }) {
  let ticker = null, grace = null, stopped = false;
  const armGrace = () => {
    if (grace) return;                       // one question at a time
    grace = timers.setTimeout(() => { grace = null; if (!stopped) { stop(); onDead(`нет ответа за ${Math.round(graceMs / 1000)} с`); } }, graceMs);
  };
  const probe = () => { if (stopped) return; send({ type: 'heartbeat' }); armGrace(); };
  const seen = () => { if (grace) { timers.clearTimeout(grace); grace = null; } };
  const start = () => { stopped = false; if (!ticker) ticker = timers.setInterval(probe, intervalMs); };
  const stop = () => { stopped = true; if (ticker) { timers.clearInterval(ticker); ticker = null; } seen(); };
  return { start, stop, probe, seen, get waiting() { return !!grace; } };
}
